import {DESK_SETTING} from './endpoint'
import {GET_ALL_RULES, CREATE_RULE, EDIT_RULE, DELETE_RULE, GET_RULE} from './types'
import {apiAction} from './api'

export function createRule(data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules`,
    method: 'POST',
    label: CREATE_RULE,
    data,
    showToast: true,
    successMessage: 'Rule Created',
  })
}

export function getRules(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules`,
    method: 'GET',
    label: GET_ALL_RULES,
    data,
  })
}

export function getRule(id) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules/${id}`,
    method: 'GET',
    label: GET_RULE,
  })
}

export function deleteRule(id) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules/${id}`,
    method: 'DELETE',
    label: DELETE_RULE,
    showToast: true,
    successMessage: 'Rule Deleted',
  })
}

export function editRule(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules/${id}`,
    method: 'PUT',
    label: EDIT_RULE,
    data,
    showToast: true,
    successMessage: 'Rule Updated',
  })
}

export function editRuleStatus(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/rules/${id}/status`,
    method: 'PUT',
    label: EDIT_RULE,
    data,
    showToast: true,
    successMessage: 'Status Updated',
  })
}
